//@ts-nocheck
import { useState, useEffect } from 'react';
import type { NextPage } from 'next';
import Link from 'next/link';
import Image from 'next/image';
import { BailetsBlock } from '../../ModalCopy.styles';
import { CloseVideoIcon, LogoMartins } from '@assets/svgs';
import $ from 'jquery';
import cybersecurity_AI from '@assets/cybersecurity_AI.png';
import Layout from '@components/Layout';

type CybersecurityaiProps = {
  isClosed?: () => void;
  showImg?: boolean | string;
  showMedia?: boolean | string;
};

export const Cybersecurityai = ({ isClosed }: CybersecurityaiProps) => {
  return (
    <Layout>
      <BailetsBlock style={{ overflow: 'hidden'}}>
        <CloseVideoIcon
          animation="closeIcon"
          color="#000"
          isActive={isClosed}
        />
        <LogoMartins
          width={70}
          height={65}
          color="rgba(0,0,0,0.5)"
          animation="mansion"
        />
        <h3>CYBERSECURITY WORLD</h3>
        <span style={{ marginBottom: '25px', fontWeight: '400' }}>
          ETHICAL HACKING | AI
        </span>

        <Image src={cybersecurity_AI} width={1280} height={720} alt="" />

        <iframe
          scrolling="no"
          className="iframe_desktop"
          src="https://docs.google.com/document/d/1jlqnsk7CL3lio2fIyABxWqwSZ2iq9JlkMFney96AJ14/pub?embedded=true"
        ></iframe>
        <iframe
          scrolling="no"
          className="iframe_mobile"
          src="https://docs.google.com/document/d/1jlqnsk7CL3lio2fIyABxWqwSZ2iq9JlkMFney96AJ14"
        ></iframe>
      </BailetsBlock>
    </Layout>
  );
};
